import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import SetTitle from '../../components/shared/SetTitle';
import TypeOfPersonSelect from '../../components/shared/TypeOfPersonSelect';
import { request, handleRequestErrors } from '../../helpers/Requests'

import { adminUser, managerUser, capitalizeAllWords, renderErrors } from '../../utilities/Forms.js'
import { debounce, hideResidentsCheck, TYPE_OF_PEOPLE } from '../../utilities/Generic.js'

class CreateRelationship extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handlePersonSearch = this.handlePersonSearch.bind(this);
    this.debouncedHandleSearch = debounce(this.handlePersonSearch, 500);
  }

  state = {
    search: "",
    type_of_person: "",
    person_id: this.props.person_id || "",
    relationship_type: "",

    people: [],
    originalPerson: {full_name: this.props.other_person_name, id: this.props.other_person_id},

    hideResidents: hideResidentsCheck(),

    peopleLoaded: true,
    updated: "",
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleSearchChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    if (name === "search") {
      this.setState({peopleLoaded: false});
      this.debouncedHandleSearch(event)
    }
    else {
      this.handlePersonSearch(event)
    }
  }

  handlePersonSearch(event) {
    if (this.state.search === "") {
      this.setState({
        peopleLoaded: true
      })

      return
    }

    let dataObject = {
      search: this.state.search,
      type_of_person: this.state.type_of_person
    }

    let name = event.target.name;
    let value = event.target.value;

    dataObject[name] = value

    let params = `person[partial]=${dataObject.search}`

    if (dataObject.type_of_person) {
      params += `&person[type]=${dataObject.type_of_person}`
    }

    request("GET", `/v1/a/people/scoped_names_and_ids?${params}`, null, () => { this.setState({ unauthorized: true }) })
      .then(data => {
        const people = data.filter(person => person.id.toString() !== this.props.other_person_id)

        this.setState({ people: people, peopleLoaded: true })
      })
      .catch(error => handleRequestErrors(this, error, {peopleLoaded: true}))
  }

  handleSubmit(event) {
    this.setState({
      updated: "",
      updating: true
    })

    const other_person_id = this.props.other_person_id;

    const json = JSON.stringify({
      "relationship": {
        "person_relationships_attributes": [{
          "relationship_type": this.state.relationship_type.split('/')[0],
          "person_id": this.state.person_id,
        }, {
          "relationship_type": this.state.relationship_type.split('/')[1],
          "person_id": other_person_id,
        }]
      }
    })

    request('post', '/v1/a/relationships', json)
      .then(data => {
        this.setState({ person_id: "", relationship_type: "", updated: true, updating: false, errors: "" })

        if (this.props.person_id){
          sessionStorage.setItem("updateSuccess", "Relationship created successfully!");
          this.props.closeNewPanel()
        }
      })
      .catch(error => {
        handleRequestErrors(this, error, { updating: false, updated: false })

        if (error.errors) {
          this.setState({ errors: { "person_relationships.person": error.errors } })
        }
      })

    event.preventDefault();
  }

  renderPersonSelect() {
    if (this.state.peopleLoaded === false) {
      return (
        <select name="person_id">
          <option value="">Loading...</option>
        </select>
      )
    }

    if (this.props.person_name) {
      return (
        <>
          <label className="column">Person:</label>{ renderErrors(this.state.errors, 'person_relationships.person', 'person') }
          <select name="person_id" disabled={true}>
            <option value="">{this.props.person_name}</option>
          </select>
        </>
      )
    }

    const { type_of_person, person_id, people, hideResidents } = this.state;

    let type_of_people = TYPE_OF_PEOPLE

    if (hideResidents) {
      type_of_people = type_of_people.filter(type_of_person => type_of_person !== "resident")
    }

    return (
      <select name="person_id" onChange={this.handleChange} value={person_id}>
        <option value="">Select</option>
        {type_of_people.map(current_type_of_person =>
          (type_of_person === current_type_of_person || !type_of_person) &&
          <optgroup label={capitalizeAllWords(current_type_of_person)} key={current_type_of_person}>
            {people.filter(person => person.type_of_person === current_type_of_person).map(person => (
              <option value={person.id} key={person.id}>{person.full_name}</option>
            ))}
          </optgroup>
        )}
      </select>
    )
  }

  renderUpdated(updated) {
    if (updated) {
      return (
        <div>
          Created!
        </div>
      );
    }
  }

  renderSaveButton() {
    if (adminUser() || managerUser) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderAlternateName(person) {
    if (person.alternate_name !== null) {
      return `(${person.alternate_name})`
    }
  }

  renderRelationshipDescription(person_id) {
    if (person_id && this.state.relationship_type) {
      const selectedPerson = this.state.people.filter((person) => person.id.toString() === person_id)[0]
      const originalPerson = this.state.originalPerson

      return (
        <div>
          <div>{selectedPerson?.full_name || this.props.person_name} will be registered as {originalPerson.full_name}'s {this.state.relationship_type.split('/')[0]}.</div>
          <br/>
        </div>
      )
    }
  }
  render() {
    const { type_of_person, search, person_id, relationship_type, updated, unauthorized, error, errors } = this.state;

    if (localStorage.license === "entry") {
      return <Redirect to="/upgrade" />
    }

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return (
        <div className="warning-box">{error}</div>
      )
    }

    return (
      <div>
        <SetTitle title={"New Relationship | People"} />

        <form className="settings big-settings" onSubmit={this.handleSubmit}>
          {!this.props.person_id &&
            <>
              <label className="column">Type:</label>
              <TypeOfPersonSelect defaultText="All" value={type_of_person} onChange={this.handleSearchChange} />

              <div className="row">
                <label className="column">Person:</label>{ renderErrors(errors, 'person_relationships.person', "") }
                <input placeholder="Enter text to search" className="no-margin" type="text" name="search" value={search} onChange={this.handleSearchChange} />
              </div>
            </>
          }

          {this.renderPersonSelect()}

          <div className="row">
            <label className="column">Relationship Type:</label>{ renderErrors(errors, 'person_relationships.relationship_type') }
            <select name="relationship_type" onChange={this.handleChange} value={relationship_type}>
              <option value="">Select</option>
              <option value="Parent/Child">Parent</option>
              <option value="Child/Parent">Child</option>
              <option value="Spouse/Spouse">Spouse</option>
              <option value="Grandparent/Grandchild">Grandparent</option>
              <option value="Grandchild/Grandparent">Grandchild</option>
              <option value="Friend/Friend">Friend</option>
              <option value="Other Relative/Other Relative">Other Relative</option>
              <option value="Professional/Client">Professional</option>
              <option value="Client/Professional">Client</option>
              <option value="Other/Other">Other</option>
            </select>
          </div>

          { this.renderRelationshipDescription(person_id)}
          { this.renderSaveButton() }
          { this.renderUpdated(updated) }
        </form>
      </div>
    );
  }
}

export default CreateRelationship;
